var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "lock-screen" }, [
        _c(
          "div",
          { staticClass: "lock-card" },
          [
            _c("a-icon", { staticClass: "lock-icon", attrs: { type: "lock" } }),
            _c("div", { staticClass: "lock-title" }, [_vm._v("屏幕已锁定")]),
            _c("div", { staticClass: "lock-info" }, [
              _vm._v(_vm._s(_vm.cashierName) + " · " + _vm._s(_vm.clock)),
            ]),
            _c("a-input-password", {
              ref: "pwd",
              staticClass: "lock-input",
              attrs: { placeholder: "输入登录密码解锁" },
              on: { pressEnter: _vm.unlock },
              model: {
                value: _vm.password,
                callback: function ($$v) {
                  _vm.password = $$v
                },
                expression: "password",
              },
            }),
            _c(
              "a-button",
              {
                attrs: { type: "primary", block: "", loading: _vm.unlocking },
                on: { click: _vm.unlock },
              },
              [_vm._v("解锁")]
            ),
            _vm.failCount
              ? _c("div", { staticClass: "lock-fail" }, [
                  _vm._v("密码错误，请重试"),
                ])
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }